
import React, { useState, useEffect } from 'react'
import MaterialTable from '@material-table/core'
import {
  deleteRolUserConfig,
  getUsersToConfig,
  postRolUserConfig,
  getRolUser,
} from '@auteco/services/motosSnopServices'
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { AiFillEdit } from 'react-icons/ai'
import { Colors } from '@auteco/theme'
import DeleteIcon from '@material-ui/icons/Delete'
import { initialAlert } from '@auteco/constants'
import { Alert } from '../Alert'
import { useStyles } from './styles'

const ConfiguracionUsuariosContainer = () => {

  const [infoBars, setInfoBars] = useState({})
  const [users, setUsers] = useState([])
  const [idEditable, setIdEditable] = useState('')
  const [rolId, setRolId] = useState('')
  const [alertInfo, setAlertInfo] = useState(initialAlert)
  const classes = useStyles()

  const getInfoBars = async () => {
    const response = await getRolUser()
    if (response) {
      setInfoBars(response.iam.nombre)
    }
  }

  const getUsers = async () => {
    const { usuarios } = await getUsersToConfig()
    if (usuarios) {
      setUsers(usuarios)
    }
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const searchSelectedUser = ({ id }) => {
    const selectedUser = users.find((user) => user.id === id)
    return `${selectedUser.nombre} ${selectedUser.apellido}`
  }

  const postRolUser = async ({ userId }) => {
    const body = {
      rol_id: rolId,
      usuario_id: userId,
    }
    const { success } = await postRolUserConfig({ params: body })
    if (success === 1) {
      getUsers()
      setRolId('')
      setIdEditable('')
    } else {
      setRolId('')
      setIdEditable('')
      setAlertInfo({
        open: true,
        title: 'Lo sentimos',
        content: 'No se ha podido asignar el rol',
        textBtn1: 'Cerrar',
        textBtn2: '',
        funcBtn: onCloseAlert,
        onClose: onCloseAlert,
      })
    }
  }

  const deleteRolUser = async ({ user }) => {
    const body = {
      userId: user.id,
      rolId: user.rol_id,
    }
    const { success } = await deleteRolUserConfig({ params: body })
    if (success) {
      getUsers()
      setAlertInfo(initialAlert)
    }
  }

  const handleDeleteRolUser = ({ user }) => {
    setAlertInfo({
      open: true,
      title: '¡Espera!',
      content: `Vas a remover el rol a ${searchSelectedUser({
        id: user.id,
      })}, ¿deseas continuar?`,
      textBtn1: 'Cerrar',
      textBtn2: 'Continuar',
      funcBtn: () => deleteRolUser({ user }),
      onClose: onCloseAlert,
    })
  }
  const handleCancel = () => {
    setIdEditable('')
    setRolId('')
  }

  const handleChangeRol = ({ value }) => {
    setRolId(value)
  }

  const columns = [
    {
      title: 'Nombre',
      field: 'nombre',
      render: (rowData) => `${rowData.nombre} ${rowData.apellido}`,
    },
    {
      title: 'Rol',
      field: 'rol_nombre',
      render: (rowData) =>
        rowData.rol_nombre === null ? 'Sin asignar' : rowData.rol_nombre,
    },
    {
      title: 'Seleccionar o remover rol',
      field: 'Seleccionar o remover rol',
      render: (rowData) =>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {idEditable === rowData.id ? (
              <div className={classes.editBtnsContainer}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="select-rol" className={classes.label}>
                    Rol
                  </InputLabel>
                  <Select
                    labelId="select-rol"
                    label="Rol"
                    variant="outlined"
                    onChange={(e) => handleChangeRol({ value: e.target.value })}
                  >
                    <MenuItem value={3}>Finanzas</MenuItem>
                    <MenuItem value={4}>Comprador</MenuItem>
                  </Select>
                </FormControl>
                <div>
                  <Button className={classes.cancelBtn} onClick={handleCancel}>
                    Cancelar
                  </Button>
                  <Button
                    color="tumblr"
                    className={classes.acceptBtn}
                    disabled={rolId === ''}
                    onClick={() => postRolUser({ userId: rowData.id })}
                  >
                    Enviar
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <IconButton
                  className={classes.actionBtn}
                  onClick={() => setIdEditable(rowData.id)}
                >
                  <AiFillEdit />
                </IconButton>
                <IconButton
                  className={classes.actionBtn}
                  onClick={() => handleDeleteRolUser({ user: rowData })}
                >
                  <DeleteIcon className={classes.iconBtn} />
                </IconButton>
              </>
            )}
          </div>
    },
  ]

  useEffect(() => {
    getUsers()
    getInfoBars()
  }, [])

  if (infoBars !== 'Comprador') {
    return (
      <div>
        <p>No tienes permisos para acceder a esta página</p>
      </div>
    )
  }
  return (
    <>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        funcBtn={alertInfo.funcBtn}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}   
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      <MaterialTable
        columns={columns}
        data={users}
        title=""
        options={{
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
          headerStyle: {
            backgroundColor: Colors.BLUE,
            color: '#f1f1f1',
            fontSize: '14px',
            fontWeight: 700,
            position: 'sticky', zIndex: '10'
          },
          maxBodyHeight: '500px',
          actionsColumnIndex: -1,
          fixedHeader: true,
        }}
      />
    </>
  )

}

export default ConfiguracionUsuariosContainer 